import classNames from 'classnames';
import React, { useState } from 'react';
import { RicosAlignmentContextProvider, RicosNodeContextProvider } from 'ricos-context';
import { C as CollapsibleListContextProvider, s as styles } from './collapsibleListContext.js';
import { g as getAlignmentFromDirection } from './utils.js';
import '@tiptap/core';
import '@tiptap/pm/model';
import 'lodash';
import 'ricos-content';

var ROOT = "collapsibleListComponent";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var CollapsibleList = function CollapsibleList(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    RicosNodesRenderer = _ref.RicosNodesRenderer,
    NodeViewContainer = _ref.NodeViewContainer;
  var _a;
  var _useState = useState(void 0),
    expandedItemId = _useState[0],
    setExpandedItemId = _useState[1];
  var styles$1 = styles;
  var direction = ((_a = node.collapsibleListData) == null ? void 0 : _a.direction.toLowerCase()) || "ltr";
  var alignment = getAlignmentFromDirection(direction);
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement("div", {
    className: classNames(styles$1[direction], styles$1.listDimensions),
    "data-hook": ROOT
  }, /* @__PURE__ */React.createElement(RicosAlignmentContextProvider, {
    textAlignment: alignment
  }, /* @__PURE__ */React.createElement(RicosNodeContextProvider, {
    parentNode: node,
    parentIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(CollapsibleListContextProvider, {
    expandedItemId: expandedItemId,
    setExpandedItemId: setExpandedItemId
  }, /* @__PURE__ */React.createElement(RicosNodesRenderer, {
    nodes: node.nodes
  }))))));
};
var CollapsibleListRenderer = function CollapsibleListRenderer(_a) {
  var _b = _a,
    node = _b.node,
    props = __objRest(_b, ["node"]);
  return /* @__PURE__ */React.createElement(CollapsibleList, __spreadValues({
    key: node.id,
    node: node
  }, props));
};

export { CollapsibleListRenderer as default };

import 'wix-rich-content-plugin-collapsible-list/dist/loadable/viewer/es/styles.viewer.min.global.css'